import React, { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { GetPrinterJpkDocumentDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import Button from '../../../common/components/Button';

import { PrinterJpkDocumentPreviewModal } from './PrinterJpkDocumentPreviewModal';

export const PrinterJpkDocumentPreviewLink: React.FC<{
  printerJpkDocumentId: string;
}> = ({ printerJpkDocumentId }) => {
  const spd = useSpdCore();
  const [showPreview, setShowPreview] = useState(false);
  const [loading, setLoading] = useState(false);
  const [document, setDocument] = useState<GetPrinterJpkDocumentDto | null>(
    null,
  );

  const handleClick = async () => {
    setLoading(true);
    try {
      const doc = await spd.printerJpkDocuments.getById(printerJpkDocumentId);
      setDocument(doc);
      setShowPreview(true);
    } catch (error) {
      console.log(`Wystąpił problem z wczytaniem dokumentu JPK. ${error}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <OverlayTrigger
        overlay={
          <Tooltip style={{ position: 'fixed' }}>Podgląd dokumentu JPK</Tooltip>
        }
      >
        <Button
          variant="link"
          className="ms-1 p-0"
          onClick={handleClick}
          disabled={loading}
        >
          <Icon.Eye />
        </Button>
      </OverlayTrigger>
      {document && (
        <PrinterJpkDocumentPreviewModal
          show={showPreview}
          onHide={() => {
            setShowPreview(false);
            setDocument(null);
          }}
          document={document}
        />
      )}
    </>
  );
};
